module.exports = __webpack_public_path__ + "media/components/assets/icons/label_new-c2e930858f222d299ca99c669ac7a3e3.svg";